<div class="w-full p-20 bg-pastel-blue border-box h-full scroll-y">
  <div class="flex gap-20 mb-20">
    <div>
      <img src="assets/list_icon.svg" alt="list">
    </div>
    <div>
      <h3 class="light-blue no-margin text-lg">Récapitulatif de votre protocole d'accord préélectoral</h3>
      <p class="dark-gray no-margin text-sm">Vérifiez et validez chaque section avant de générer votre document.</p>
    </div>
  </div>

  <div class="flex flex-column gap-20">
    <div class="p-20 bg-white border-box">
      <!-- <div style="display: grid; grid-template-columns: 20% 38% 38%; gap: 20px; width: 100%;"> -->
      <div class="flex w-full content-between gap-20">
        <div style="width: 16%;">
          <p class="dark-blue no-margin bold">
            Progression de la validation
          </p>
          <p class="text-sm mb-10" [ngClass]="validatedCategoriesCount === 9 ? 'strong-green' : 'dark-gray'">
            {{validatedCategoriesCount}} / 9 sections validées
          </p>
        </div>

        <div style="width: 42%;">
          <p class="dark-blue no-margin bold">
            Progression de la validation
          </p>
          <p class="dark-gray text-sm mb-10">
            Le Protocole d’Accord Préélectoral (PAP) est la "règle du jeu" de vos
            élections. Une relecture attentive garantit la conformité juridique de votre scrutin et évite tout risque de
            recours.
          </p>
        </div>

        <div style="width: 42%;">
          <p class="dark-blue no-margin bold">
            Comment faire ?
          </p>
          <p class="dark-gray text-sm mb-10">
            Parcourez les 9 sections ci-dessous. Chaque feu vert confirme que vos paramètres sont prêts
            pour l'édition finale. Prenez votre temps : la qualité de votre document dépend de cette dernière
            vérification.
          </p>
        </div>
      </div>

      <div>
        <div id="progress-bar" class="mt-20"
          style="width: 100%; background-color: #e0e0e0; border-radius: 8px; height: 24px; overflow: hidden;">
          <div [style.width.%]="verificationPercentage"
            [style.background]="verificationPercentage === 100 ? 'linear-gradient(90deg, #63BA67 0%, #7BC87F 100%)' : 'linear-gradient(90deg, #4A90E2 0%, #5BA3F5 100%)'"
            style="height: 100%; transition: width 0.3s ease, background 0.3s ease; display: flex; align-items: center; justify-content: center;">
            <span *ngIf="verificationPercentage > 0" style="color: white; font-weight: bold; font-size: 12px;">{{ verificationPercentage }}%</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="needPap == false" class="bg-white p-20">
      <h2 class="dark-blue no-margin text-center mb-5">Vous pouvez passer directement à l'étape suivante.</h2>
      <p class="mb-20 grey no-margin text-center text-sm">Le protocole d'accord préélectoral ne sera pas généré
        automatiquement.</p>
      <div class="margin-center w-fit">
        <button class="action-button" (click)="goToPollCreation()">Passer à la création du scrutin</button>
      </div>
    </div>

    <div *ngIf="needPap" class="flex flex-column gap-20">
      <app-pap-information-verification [(venue)]="papValues.venue" (validated)="onValidatedComponentsChange(0)"
        (validated)="onInformationComponentValidated($event)" [(isExpanded)]="expandedView[0]"
        (editRequested)="onInformationEditRequested()"></app-pap-information-verification>
      <app-pap-employer-verification [(employer)]="papValues.employer" (validated)="onValidatedComponentsChange(1)"
        (validated)="onEmployerComponentValidated($event)" [(isExpanded)]="expandedView[1]"
        (editRequested)="onEmployerEditRequested()"></app-pap-employer-verification>
      <app-pap-union-verification [(unions)]="papValues.unions" (validated)="onUnionComponentValidated($event)"
        (editRequested)="onUnionEditRequested()" [(isExpanded)]="expandedView[2]"
        (validated)="onValidatedComponentsChange(2)"></app-pap-union-verification>
      <app-pap-length-verification [(termLength)]="papValues.termLength" (validated)="onValidatedComponentsChange(3)"
        (validated)="onLengthComponentValidated($event)" [(isExpanded)]="expandedView[3]"
        (editRequested)="onLengthEditRequested()"></app-pap-length-verification>
      <app-pap-period-verification [(period)]="papValues.period" (validated)="onPeriodComponentValidated($event)"
        (editRequested)="onPeriodEditRequested()" [(isExpanded)]="expandedView[4]"
        (validated)="onValidatedComponentsChange(4)"></app-pap-period-verification>
      <app-pap-headcount-verification [(headcount)]="papValues.headcount" [(isExpanded)]="expandedView[5]"
        (numberOfCollegesChange)="onNumberOfCollegesChanges()" (validated)="onHeadcountComponentValidated($event)"
        (editRequested)="onHeadcountEditRequested()"
        (validated)="onValidatedComponentsChange(5)"></app-pap-headcount-verification>
      <app-pap-college-verification [(colleges)]="papValues.colleges" (validated)="onValidatedComponentsChange(6)"
        [numberOfColleges]="papValues.headcount.numberOfColleges" (validated)="onCollegeComponentValidated($event)"
        (editRequested)="onCollegeEditRequested()" [(isExpanded)]="expandedView[6]"></app-pap-college-verification>
      <app-pap-application-verification [(application)]="papValues.application"
        (validated)="onValidatedComponentsChange(7)" (validated)="onApplicationComponentValidated($event)"
        [(isExpanded)]="expandedView[7]"
        (editRequested)="onApplicationEditRequested()"></app-pap-application-verification>
      <app-pap-year-verification [(year)]="papValues.electionYear" (validated)="onYearComponentValidated($event)"
        (editRequested)="onYearEditRequested()" [(isExpanded)]="expandedView[8]"
        (validated)="onValidatedComponentsChange(8)"></app-pap-year-verification>
    </div>

  </div>

</div>